import { render, staticRenderFns } from "./Borrower.vue?vue&type=template&id=59204a22&"
import script from "./Borrower.vue?vue&type=script&lang=js&"
export * from "./Borrower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports